// extracted by mini-css-extract-plugin
export var closeButton = "_48-0";